<template>
  <div @click="closeModal" v-if="modal">
    <div class="modal-wrap">
      <i class="fad fa-check-circle"></i>
      <p>Upload Completed!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Completed",
  props: ["modal"],
  methods: {
    closeModal(e) {
      // sends a signal if the target clicked is not the modal wrap
      const modal = document.querySelector(".modal");
      if (e.target === modal) {
        this.$emit("close-modal");
        this.$emit("reset-modal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.479);
  top: 0;
  z-index: 99;
  height: 100%;
  width: 100%;

  .modal-wrap {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 300px;
    padding: 2rem;
    background-color: white;

    i {
      font-size: 64px;
      color: #6236ff;
    }

    p {
      margin-top: 1rem;
      font-size: 20px;
    }
  }
}
</style>